import React from 'react';
import '../styles/PopularCastings.css';

function PopularCastings() {
  return (
    <section className="popular-castings section no-vertical-padding container">
      <h2 className="title has-text-centered">Dedicated Teams</h2>
      {/* ... Paste the rest of your "Popular Castings" HTML here ... */}
    </section>
  );
}

export default PopularCastings;
